module.exports = __webpack_public_path__ + "img/jjzh_bg2.da7f10c8.png";